import { c as _c } from "react/compiler-runtime";
import InfoIcon from "@/assets/icons/info.svg";
import { TOOLTIP_TEXTS } from "@/constants/tooltip-texts";
import { RESIDENTIAL_ADDRESS_MAX_LENGTH } from "@/lib/validation";
import { DefinitionList, DetailSection } from "@/shared/ui";
import type { Profile } from "@/features/auth/api/types";
type PersonalDetailsSectionProps = Readonly<{
  profile: Profile;
  isLoading: boolean;
  name: string;
  residentialAddress: string;
  roleLabel: string;
  onNameChange: (value: string) => void;
  onResidentialAddressChange: (value: string) => void;
}>;
export function PersonalDetailsSection(t0) {
  const $ = _c(13);
  const {
    profile,
    isLoading,
    name,
    residentialAddress,
    roleLabel,
    onNameChange,
    onResidentialAddressChange
  } = t0;
  const isStreamer = profile.accountType === "STREAMER";
  const t1 = isStreamer ? 4 : 3;
  let t2;
  if ($[0] !== isStreamer || $[1] !== name || $[2] !== onNameChange || $[3] !== onResidentialAddressChange || $[4] !== profile.email || $[5] !== profile.streamingUsername || $[6] !== residentialAddress || $[7] !== roleLabel) {
    t2 = isStreamer ? [{
      label: "Name",
      value: name,
      editable: true,
      onChange: onNameChange
    }, {
      label: "Username",
      value: profile.streamingUsername ?? "\u2014"
    }, {
      label: "Email",
      value: profile.email ?? "\u2014"
    }, {
      label: "Address",
      value: residentialAddress,
      icon: <InfoIcon width={14} height={14} />,
      tooltip: TOOLTIP_TEXTS.account.residentialAddress,
      editable: true,
      multiline: true,
      maxLength: RESIDENTIAL_ADDRESS_MAX_LENGTH,
      onChange: onResidentialAddressChange
    }] : [{
      label: "Name",
      value: name,
      editable: true,
      onChange: onNameChange
    }, {
      label: "Email",
      value: profile.email ?? "\u2014"
    }, {
      label: "Account Type",
      value: roleLabel || "\u2014"
    }];
    $[0] = isStreamer;
    $[1] = name;
    $[2] = onNameChange;
    $[3] = onResidentialAddressChange;
    $[4] = profile.email;
    $[5] = profile.streamingUsername;
    $[6] = residentialAddress;
    $[7] = roleLabel;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== isLoading || $[10] !== t1 || $[11] !== t2) {
    t3 = <DetailSection label="PERSONAL DETAILS"><DefinitionList isLoading={isLoading} loadingRows={t1} items={t2} /></DetailSection>;
    $[9] = isLoading;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}